import React, { useState } from "react";
// import "./Detail.css";
import { Col, Row } from "react-bootstrap";
import { FaPhone, FaUser } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
const Gayno = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone : "",
    email: "",
  });
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation (simple example)
    if (!formData.name || !formData.phone || !formData.email) {
      setMessage("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:4000/api/send-mail",
        formData
      );
      setMessage(response.data.message || "Request sent successfully!");
    } catch (error) {
      setMessage("Failed to send the request. Please try again.");
    }
  };
  return (
    <section className="space shape-mockup-wrap">
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-lg-7">
            <div className="page-single">
              <div className="page-meta" style={{ marginTop: "0px" }}>
                <Link className="page-tag">
                  Gynecomastia Surgery (Male Breast Reduction)
                </Link>{" "}
              </div>
              {/* <div className="service-img">
              <img
                src="https://html.themeholy.com/tourm/demo/assets/img/destination/destination-details.jpg"
                alt=""
                style={{height:'400px'}}
              />
            </div> */}
              <div className="page-content d-block">
                {/* <h2 className="box-title">
              Surgery Saathi: Expert Rhinoplasty Services in Delhi
              </h2> */}
                <h3>What is Gynecomastia?</h3>
                <p className="box-text mb-30 detail-page-paraas">
                  Gynecomastia is a condition where men develop excess breast
                  tissue, which can make the chest look enlarged. This can be
                  caused by hormones, genetics, or certain medications.
                  Gynecomastia surgery helps reduce the size of male breasts,
                  giving a flatter, more toned chest.
                </p>

                <div className="service-inner-img mb-40">
                  <img
                    src="/Images/gyno.jpg"
                    // src="https://img.freepik.com/premium-photo/doctor-conducting-virtual-consultation-with-patient_1280275-220305.jpg?w=900"
                    alt=""
                    style={{ height: "300px", objectFit: "cover" }}
                  />
                </div>
                <p
                  className="box-text mb-30 detail-page-paraas"
                  style={{
                    background: "aliceblue",
                    padding: "10px",
                    fontStyle: "italic",
                  }}
                >
                  Gynecomastia surgery is performed to reduce excess breast
                  tissue in males, improving comfort and self-esteem, often due
                  to hormonal imbalances or weight changes.
                </p>
                <div className="gynecomastia_stages_p">
                  <h2 style={{ fontSize: "18px", fontWeight: "400" }}>
                    Gynecomastia Stages
                  </h2>
                  <img
                    src="https://www.gynecomastiasurgery.co.in/wp-content/uploads/2015/12/Gynecomastia-Grading.jpg"
                    alt=""
                  />
                  <br />
                  <br />
                  <br />
                  <p>
                    <strong>Gynecomastia occurs in 4 stages:</strong>
                  </p>
                  <p>
                    <strong>Grade 1</strong>: This is a basic swelling stage
                    where the excess gland tissues are not too revealing. There
                    is no extra skin development that needs to be taken care of.
                    But some obvious signs give away the presence of this issue
                    and the pressing need to solve it.
                  </p>
                  <p>
                    <strong>Grade 2</strong>: This is where there is no extra
                    development easily recognisable. But the males may feel
                    slight enlargement and swelling in nipples causing
                    discomfort.
                  </p>
                  <p>
                    <strong>Grade 3</strong>: A step over the Grade 2 stage
                    reveals a prominent issue with swollen gland tissues with
                    extra growth and considerable swelling in the skin and
                    nipples.
                  </p>
                  <p>
                    <strong>Grade 4</strong>: This is the most problematic stage
                    with very easily recognizable swelling and too much gland
                    tissue growth causing concern for visible aesthetics and
                    comfort.
                  </p>
                  <p>
                    The first step to understanding, if you have a problem, is
                    finding signs and then shortlisting the grade that you are
                    on. Consultants may help you find the right problematic
                    stage and possible solutions.
                  </p>
                  <br />
                  <h2>How to Identify Each Gynecomastia Stage?</h2>
                  <p>
                    <strong>
                      There are some obvious symptoms of each gynecomastia
                      stage:
                    </strong>
                  </p>
                  <p>
                    <strong>Grade 1</strong>: Discoloration in nipples is one of
                    the most obvious signs. The conical shape of nipples may be
                    experienced while there are no obvious signs when clothed.
                  </p>
                  <p>
                    <strong>Grade 2</strong>: Feeling slightly swollen breasts
                    is an obvious sign along with stiff nipples and harder
                    breasts experienced prominently in loose clothing.
                  </p>
                  <p>
                    <strong>Grade 3</strong>: Feeling prominent chest protrusion
                    causes self-consciousness to suffer. The breasts are droopy
                    and easily visible through loose clothing.
                  </p>
                  <p>
                    <strong>Grade 4</strong>: A very difficult stage where harsh
                    protrusion may be seen. This is more similar to a look
                    resembling a woman. This significant growth is a serious
                    matter treatable only through surgery.
                  </p>
                  <p>
                    Earlier stages are more easily treated with outstanding
                    results and no hassle. It is better to keep a lookout for
                    such a problem and take action if a slight feeling arises.
                  </p>
                  {/* <h2>How to Get Rid of Gynecomastia?</h2>
                  <p>
                    Experiencing gynecomastia is a journey of self-reflection
                    and confidence that is bound to be shaken. There are easy
                    and{" "}
                    <a
                      href="https://www.resplendentcosmetics.com/blog/how-to-tell-if-you-have-gynecomastia.php"
                      target="_blank"
                    >
                      quick ways of getting rid of gynecomastia
                    </a>
                    . One process that can help the most with guaranteed results
                    is surgery. It is preferred to opt for it only if the
                    problem is in the later stages with no hope for non-surgical
                    processes. This procedure is most commonly carried out in
                    males 50 years old or older by using processes such as
                    liposuction and removing excessive tissues.
                  </p> */}
                </div>

                <h4 style={{ fontSize: "18px", fontWeight: "400" ,marginTop:'15px'}}>
                  Why Choose Gynecomastia Surgery?
                </h4>
                <div className="checklist" style={{ marginTop: "20px" }}>
                  <ul>
                    <li>Men opt for this surgery to:</li>
                    <li>
                      Remove excess tissue and achieve a firmer, flatter chest
                    </li>
                    {/* <li>
                    Expert guide always guide you and give informations.
                  </li> */}
                    <li>Improve chest shape and appearance</li>
                    {/* <li>Helping all traveler for Money Exchange.</li> */}
                    <li>
                      Feel more confident in tight clothing or during physical
                      activities
                    </li>
                    {/* <li>Fixing a deviated septum to improve breathing</li> */}
                  </ul>
                </div>
              </div>
              {/* <p className="box-text mb-30 detail-page-paraas">
              For those seeking to enhance appearance, surgery is typically
              recommended only after nasal growth has completed, while
              functional corrections can be performed at a younger age.
            </p> */}
              <div className="th-comments-wrap style2">
                <h2 className="blog-inner-title h4">
                  The surgery typically involves one of the following methods:
                </h2>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">Liposuction</h3>
                        <p className="text">
                          Removes excess fat through small incisions using a
                          thin tube.
                        </p>
                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Excision</h3>
                            </div>
                            <p className="text">
                              Removes glandular tissue or excess skin through
                              surgery, used for more severe cases.
                            </p>
                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {/* <li className="th-comment-item">
                  <div className="th-post-comment">
                    <div className="comment-content">
                      <div className="">
                        <h3 className="name">Photographic Documentation</h3>
                      </div>
                      <p className="text">
                        Photos will be taken from various angles for pre- and
                        post-surgery comparison, aiding in discussion of
                        surgical goals.
                      </p>
                      <div className="reply_and_edit">
                        <i className="fa-solid fa-thumbs-up" />
                      </div>
                    </div>
                  </div>
                </li> */}
                </ul>
              </div>

              <div style={{ marginTop: "50px" }}>
                <h2
                  className="box-title"
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    background: "aliceblue",
                    padding: "10px",
                  }}
                >
                  The procedure usually lasts 1-2 hours and is performed under
                  general anesthesia.
                </h2>
              </div>
              {/* <div>
              <p
                className="box-text detail-page-paraas"
                style={{ margin: "5px" }}
              >
                Involves a small incision at the base of the nose, providing
                greater visibility and access for extensive reshaping. This
                technique is ideal for significant alterations.
              </p>
              <div className="checklist" style={{ marginTop: "15px" }}>
                <ul>
                  <li>
                    Autologous cartilage grafts taken from the nasal septum
                    (the wall inside the nose that divides one air passage
                    from the other) offers the best chance for a natural
                    result. If cartilage and bone have already been removed
                    from the nasal septum, then ear or rib cartilage and
                    sometimes bone from the skull are other options.
                  </li>
                  <li>
                    Although solid silicone implants are available for nasal
                    surgery, these are foreign materials that may become
                    infected or react poorly with the nasal tissues and have
                    to be removed. That is why natural cartilage, if a supply
                    is available, is the most trouble-free option.
                  </li>

                  <li>
                    Fillers or fat grafts may also be injected to smooth the
                    nose, to camouflage deformities or indentations, or to add
                    volume in desired areas.
                  </li>
                </ul>
              </div>
            </div> */}
              <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Recovery</h2>
                <p
                  className="box-text detail-page-paraas"
                  style={{ margin: "5px" }}
                >
                  After the surgery, you may feel some soreness and see
                  swelling, but pain is typically mild and controlled with
                  medication. A compression vest may be worn to help with
                  healing. Most patients can return to daily activities within a
                  week, but full recovery may take a few weeks.
                </p>
                {/* <div
                className="procedure-checklist"
                style={{ marginTop: "15px", listStyle: "none" }}
              >
                <ul>
                  <li>
                    1. <b>Administration of Anesthesia:</b> The patient
                    receives either local or general anesthesia, depending on
                    the complexity of the surgery.
                  </li>
                  <li>
                    <b>2. Making Incision:</b> An incision is created, either
                    inside the nose, at the base, or between the nostrils,
                    depending on the chosen technique.
                  </li>
                  <li>
                    <b>3. Reshaping the Nose Structure:</b> The surgeon
                    readjusts the bone and cartilage underneath the skin.
                    Cartilage may be taken from within the nose, the ear, or,
                    in rare cases, the ribs, minimizing the risk of immune
                    rejection.
                  </li>
                  <li>
                    <b>4. Deviated Septum Correction:</b> If necessary, the
                    surgery corrects any crooked or deviated septum to improve
                    breathing
                  </li>
                  <li>
                    <b>5. Closing the Incision:</b> The surgeon replaces the
                    nose skin and tissue, stitching the incision closed.
                  </li>
                  <li>
                    <b>6. Applying Bandages:</b> Bandages are applied to cover
                    the treated area, supporting the healing process.
                  </li>
                  <li>
                    <b>7. Supporting Garment:</b> A splint or gauze is worn
                    for a few weeks, and patients should follow their
                    surgeon's post-operative instructions to promote healing.
                  </li>
                </ul>
              </div> */}
              </div>
              <h2
                className="box-title"
                style={{ fontSize: "20px", margin: "10px 0px" }}
              >
                Benefits of Gynecomastia Surgery:
              </h2>
              {/* <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Post-Operative Care</h2>
              </div> */}
              <div>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>A flatter, more masculine chest</li>
                    <li>Improved self-esteem</li>

                    <li>Easier participation in physical activities</li>
                  </ul>
                </div>
              </div>

              {/* <div style={{ marginTop: "50px" }}>
              <h2 className="box-title">Expected Results and Recovery</h2>
            </div> */}
              {/* <p
              className="box-text detail-page-paraas"
              style={{ margin: "5px" }}
            >
              Swelling generally subsides within weeks, with final results
              becoming clear over time. Most patients can return to daily
              activities within a week, while strenuous activities should be
              avoided for about two to three weeks.
            </p> */}
            </div>
          </div>
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area style3">
              <div className="breakcrumbss">
                <div className="aside-detail-firstdivc">Popular Services</div>
                <ul className="detail-page-uls">
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/gynaecomastia">Gynecomastia</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/rhinoplasty">Rhinoplasty</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/lipoma-removal">Lipoma Removal</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/ophthalmology">Ophthalmology</Link>
                  </li>
                </ul>
              </div>
              <div className="breakcrumbss" style={{ marginTop: "30px" }}>
                <div className="aside-detail-firstdivc">Get Appointment</div>
                <form onSubmit={handleSubmit}>
                  <Row style={{ marginTop: "30px" }}>
                    <Col md={12} style={{ position: "relative" }}>
                      <FaUser
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="name"
                          className="aside-input-appointement"
                          placeholder="Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <FaPhone
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="phone"
                          className="aside-input-appointement"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <MdEmail
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="email"
                          name="email"
                          className="aside-input-appointement"
                          placeholder="Email Id"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12}>
                      <button type="submit" className="aside-appointment-btn">
                        Get Appointment
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gayno;
